import { render, staticRenderFns } from "./RegRenIndividual.vue?vue&type=template&id=73fb0b39&scoped=true&"
import script from "./RegRenIndividual.vue?vue&type=script&lang=js&"
export * from "./RegRenIndividual.vue?vue&type=script&lang=js&"
import style0 from "./RegRenIndividual.vue?vue&type=style&index=0&id=73fb0b39&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73fb0b39",
  null
  
)

export default component.exports